import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { LinearEncoding, Vector3 } from 'three'
// import * as dat from 'dat.gui'

// const gui = new dat.GUI()
// gui.hide()

const canvas = document.querySelector('canvas.webgl')

const cubeTextureLoader = new THREE.CubeTextureLoader()
const environmentMapTexture = cubeTextureLoader.load([
	'/environmentMaps/3/px.jpg',
	'/environmentMaps/3/nx.jpg',
	'/environmentMaps/3/py.jpg',
	'/environmentMaps/3/ny.jpg',
	'/environmentMaps/3/pz.jpg',
	'/environmentMaps/3/nz.jpg'
])

const skinTonesHex = [ 0xF2E4C1, 0xF6DBBD, 0xEFC9a5, 0xE5BB93, 0xDCB081, 0xC2976C, 0xC08B63, 0xAA6F43, 0x945C39, 0x7B4E3B, 0x64493E, 0x624A40, 0x59463F, 0x523F39, 0x563B32, 0x543733 ]
const nailTonesHex = [ 0xFFFFDF, 0xFFF9DB, 0xFFE7C3, 0xF9D9B1, 0xF0CE9F, 0xD6B58A, 0xD4A981, 0xBE8D61, 0xA87A57, 0x8F6C59, 0x78675C, 0x76685E, 0x6D645D, 0x665D57, 0x6A5950, 0x685551 ]

// const red = {r: 1, g: 0, b: 0}
const slider = document.getElementById("slider")
slider.value = "7"

const sizes = {
	width: window.innerWidth,
	height: window.innerHeight
}

let handScene

const loader = new GLTFLoader()
loader.load(
	'grip.gltf',
	function ( gltf ) {

		handScene = gltf.scene
		const hand = gltf.scene.children[0]
		
		handScene.scale.x = sizes.width / sizes.height * 0.7
		handScene.scale.y = sizes.width / sizes.height * 0.7
		handScene.scale.z = sizes.width / sizes.height * 0.7
		
		scene.add( handScene )

		hand.rotation.x = Math.PI
		hand.rotation.z = Math.PI
		hand.rotation.y = Math.PI * 1.5
		// hand.rotation.y = Math.PI * 0.5

		// skin
		const skin = hand.children[1]
		skin.material.color.setHex(skinTonesHex[slider.value]).convertSRGBToLinear()
		skin.material.metalness = 0
		skin.material.roughness = 1
		
		skin.geometry.setAttribute(
			'uv2',
			new THREE.BufferAttribute(skin.geometry.attributes.uv.array, 2)
		)
		
		skin.material.aoMap = skin.material.map
		skin.material.map = ""
		skin.material.aoMapIntensity = 0.6
		skin.material.envMap = environmentMapTexture
		
		// skin.material.encoding = sRGBEncoding
		skin.material.encoding = LinearEncoding
		
		// nails
		const nails = hand.children[2]
		nails.material.color.setHex(nailTonesHex[slider.value]).convertSRGBToLinear()
		nails.material.shininess = 1
		nails.material.metalness = 0
		nails.material.roughness = 0.5
		nails.material.envMap = environmentMapTexture
		
		// button light
		const buttonLight = hand.children[3]
		buttonLight.material.roughness = 0
		buttonLight.material.metalness = 0
		buttonLight.material.color = {r: 0, g: 1, b: 1}
		
		// metal washers
		const washers = hand.children[0]
		washers.material.color = {r:0.7,g:0.7,b:0.7}
		washers.material.metalness = 1
		washers.material.roughness = 0
		washers.material.envMap = environmentMapTexture
		
		// bolts
		const bolts = hand.children[4]
		bolts.material.color = {r:0.7,g:0.7,b:0.7}
		bolts.material.metalness = 1
		bolts.material.roughness = 0.3
		bolts.material.envMap = environmentMapTexture
		
		// knob
		const knob = hand.children[5]
		knob.material.color = {r: 0, g: 0, b: 0}
		knob.material.metalness = 0
		knob.material.roughness = 0
		knob.material.envMap = environmentMapTexture
		
		// knob grip
		const knobGrip = hand.children[6]
		knobGrip.material.color = {r: 0.1, g: 0.1, b: 0.1}
		knobGrip.material.metalness = 0
		knobGrip.material.roughness = 0.8
		knobGrip.material.envMap = environmentMapTexture

		// foam
		const foam = hand.children[7]
		foam.material.color.setHex(nailTonesHex[slider.value]).convertSRGBToLinear()
		foam.material.shininess = 0
		foam.material.metalness = 0
		foam.material.roughness = 1
		foam.material.envMap = environmentMapTexture

		slider.oninput = (e) => {
			skin.material.color.setHex(skinTonesHex[e.target.value]).convertSRGBToLinear()
			nails.material.color.setHex(nailTonesHex[e.target.value]).convertSRGBToLinear()
			foam.material.color.setHex(nailTonesHex[e.target.value]).convertSRGBToLinear()
		}

	},
	function ( xhr ) {
		console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' )
		sizes.width = canvas.offsetWidth
		sizes.height = canvas.offsetHeight
	},
	function ( error ) {
		console.error( error )
	}
)

const scene = new THREE.Scene()
scene.background = new THREE.Color( 0xffffff );

/**
 * Lights
 */

// Ambient Light
// const AmbientLight = gui.addFolder("Ambient Light")

const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
scene.add(ambientLight)
// AmbientLight.add(ambientLight, 'intensity', 0, 1, 0.001)

// Directional Light
// const DirectionalLight = gui.addFolder("Directional Light")

const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.2 )
const directionalLightPosition = new Vector3(1.8, -5.25, -13.5)
scene.add( directionalLight )
// DirectionalLight.add(directionalLight, 'intensity', 0, 1, 0.001)
// DirectionalLight.add(directionalLightPosition, 'x', -20, 20, 0.01)
// DirectionalLight.add(directionalLightPosition, 'y', -20, 20, 0.01)
// DirectionalLight.add(directionalLightPosition, 'z', -20, 20, 0.01)

// Color Directional Light
// const ColorDirectionalLight = gui.addFolder("Color Directional Light")

const colorDirectionalLight = new THREE.DirectionalLight( 0x66462b, 0.5 )
const colorDirectionalLightPosition = new Vector3(-6.15, -13.2, 13.25)
const colorDirectionalLightParams = { color: 0x66462b }
scene.add( colorDirectionalLight )
// ColorDirectionalLight.add(colorDirectionalLight, 'intensity', 0, 1, 0.001)
// ColorDirectionalLight
// 	.addColor(colorDirectionalLightParams, 'color')
// 	.onChange(() =>{ colorDirectionalLight.color.set(colorDirectionalLightParams.color) })

// ColorDirectionalLight.add(colorDirectionalLightPosition, 'x', -20, 20, 0.01)
// ColorDirectionalLight.add(colorDirectionalLightPosition, 'y', -20, 20, 0.01)
// ColorDirectionalLight.add(colorDirectionalLightPosition, 'z', -20, 20, 0.01)

const renderer = new THREE.WebGLRenderer({
	canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputEncoding = THREE.sRGBEncoding
sizes.width = canvas.offsetWidth
sizes.height = canvas.offsetHeight

window.addEventListener('DOMContentLoaded', () => {
	sizes.width = canvas.offsetWidth
	sizes.height = canvas.offsetHeight
})

const webglContainer = document.querySelector('div.webgl_container')
console.log(`w ${sizes.width} h ${sizes.height}`)

window.addEventListener('resize', () => {
	sizes.width = webglContainer.clientWidth

	if (webglContainer.offsetHeight > window.innerHeight) {
		sizes.height = window.innerHeight
	}
	else {
		sizes.height = webglContainer.offsetHeight
	}

	console.log(`w ${sizes.width} h ${sizes.height}`)

	handScene.scale.x = sizes.width / sizes.height * 0.7
	handScene.scale.y = sizes.width / sizes.height * 0.7
	handScene.scale.z = sizes.width / sizes.height * 0.7

	camera.aspect = sizes.width / sizes.height
	camera.updateProjectionMatrix()

	renderer.setSize(sizes.width, sizes.height)
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

const camera = new THREE.PerspectiveCamera(5, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 20
camera.position.y = 0
camera.position.z = 0
scene.add(camera)

const controls = new OrbitControls(camera, canvas)
controls.enableZoom = false
controls.enableDamping = true
controls.minDistance = 20
controls.maxDistance = 35
controls.autoRotate = true

// const axesHelper = new THREE.AxesHelper( 5 )
// scene.add( axesHelper )

const tick = () => {
	controls.addEventListener('start', function(){
		controls.autoRotate = false;
		setTimeout(() => {controls.autoRotate = true}, 3000)
	})

	directionalLight.position.set(
		camera.position.x + directionalLightPosition.x,
		camera.position.y + directionalLightPosition.y,
		camera.position.z + directionalLightPosition.z,
	)

	colorDirectionalLight.position.set(
		camera.position.x + colorDirectionalLightPosition.x,
		camera.position.y + colorDirectionalLightPosition.y,
		camera.position.z + colorDirectionalLightPosition.z,
	)

	controls.update()
	renderer.render(scene, camera)
	window.requestAnimationFrame(tick)
}

tick()

/**
 * Instructions
 */

document.getElementById("threejs_grip_experience_instructions").onclick = () => hide()

function hide() {
	document.getElementById("threejs_grip_experience_instructions").className = "threejs_grip_experience_instructions_hidden"
}
// hide()